import Vue from 'vue'
import Router from 'vue-router'

import Home from '@/views/Home'
import Forecast from '@/views/Forecast'
import About from '@/views/About'
import Error from '@/views/Error'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/forecast',
      name: 'forecast',
      component: Forecast
    },
    {
      path: '/about',
      name: 'about',
      component: About
    },
    {
      path: '/*',
      name: '404',
      component: Error
    },
  ]
})
